//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
Allows component  to connect the Redux store.
*/
import {connect} from 'react-redux';
/**
 parse function is used to convert a string representation of a date type into a corresponding 

 isSameDay is used to check if 2 dates are same day or not
 
 addMinutes is used to add minute to specific datetime object
*/
import {parse, isSameDay, addMinutes} from 'date-fns';
/**
 checks if pickup and dropoff location is Deviated or not
*/
import {getDeviatedPickupDropoff} from '../../../utils'
/**
 shows different day warning message.
*/
import DifferentDayWarning from './DifferentDayWarning';
/**
 shows adcance reservation warning message.
*/
import AdvanceReservationWarning from './AdvanceReservationWarning';
/**
 shows Max walk exceed warning
*/
import MaxWalkExceededWarning from './MaxWalkExceededWarning';
//#endregion

// TODO: Refactor -- component is handling too many responsibilities
/**
* It is written in Directions>>TripWarnings>>Index .
* Used in Directions>>Itinerary ,Directions>>Index 
* Shows Trip Warnings.
* @param {Object} 'Trip Details'
* @return {Object} Trip Warning Html
*/
class TripWarnings extends React.Component {
/**
* It is written in Directions>>TripWarnings>>Index .
* Used in the same component.
* Check trips requires advance reservation
* @param {Object} 'Trip Details'
* @return {Boolean} Trip require reservation or not
*/
    tripRequiresAdvanceReservation(trip) {
        //stores value for required reservation
        let requiresReservation = false;
        trip.legs.forEach(leg => {
            if ((leg.from.boardAlightType === 'DEVIATED') || (leg.to.boardAlightType === 'DEVIATED') || (getDeviatedPickupDropoff(leg))) {
                requiresReservation = true;
            }
        });
        return requiresReservation;
    }
/**
* It is written in Directions>>TripWarnings>>Index .
* Used in the same component.
* Check trip exceed maximum walking distance
* @param {Object} 'Trip Details'
* @return {Boolean} Trip exceed maximum walking distance or not
*/
    tripExceedsMaxWalking(trip) {
        //stores value for trips exceeds Walking or not
        let exceedsWalking = false;
        trip.legs.forEach(leg => {
            if (leg.walkLimitExceeded) {
                exceedsWalking = true;
            }
        });
        return exceedsWalking;
    }

    /**
* It is written in Directions>>TripWarnings>>Index .
* Used in the same component.
* Check if the trip plan is for a different day than the one intended.
* @param {Object} 'Trip Details'
* @return {Boolean} Trip Different day status
*/
    tripIsDifferentDay(trip) {
        //Trip requested date
        const requestStart = parse(this.props.requestDate);
        //Calcuate offset to get timezone offset
        const agencyOffset = (trip.legs[0].agencyTimeZoneOffset) / (60 * 1000);
        //saves current date
        const today = new Date();
        //saves time zone difference
        const timezoneDiff = agencyOffset + today.getTimezoneOffset();
        //saves trip start date        
        const tripStart = addMinutes(parse(trip.startTime), timezoneDiff);
        //returns if trip start date and request date is same or not
        return !isSameDay(tripStart, requestStart);
    }

/**
* It is written in Directions>>TripWarnings>>Index .
* Used in the same component.
* Returns warnings for the trip
* @param {Object} 'Trip Details'
* @param {Boolean} 'Is Summary'
* @return {HTMLElement} Warning Html
*/
    getWarningsForTrip(trip, isSummary=false) {
        //stores warning html as an array
        let warnings = [];
        //add differnt day warning if trip day is a different day than the one intended
        if (this.tripIsDifferentDay(trip)) {
            warnings.push(<DifferentDayWarning
                key="differentDayWarning"
                isSummary={isSummary}
            />);
        }
        //add reservation if trip require reservation
        if (this.tripRequiresAdvanceReservation(trip)) {
            warnings.push(<AdvanceReservationWarning
                key="advanceReservationWarning"
                isSummary={isSummary}
            />);
        }
        //add exceed warning if trip exceeds the maximum walking distance
        if (this.tripExceedsMaxWalking(trip)) {
            warnings.push(<MaxWalkExceededWarning
                key="maxWalkExceededWarning"
                isSummary={isSummary}
            />);
        }
        //return all warnings
        return warnings;
    }

    
/**
* It is written in Directions>>TripWarnings>>Index .
* Used in the same component.
* Returns warnings for the trip
* @return {Object} Unique trip warings
*/
    getWarningsForTrips() {
        //stores warings for each trips
        let warnings = this.props.trips.map(trip => {
            return this.getWarningsForTrip(trip, true);
        });
        warnings = [].concat(...warnings);
        //removes any duplicate objects based on key
        let removeDups = warnings.reduce((acc, curr) => {
            if (acc.find(warning => warning.key === curr.key)) {
                return [...acc];
            } else {
                return [...acc, curr];
            }
        }, []);
        return removeDups;
    }

    //Check if there is any trips or not
    isSummaryOfAllTrips() {
        return (this.props.trips.length > 0);
    }
    //Returns all trips summary
    renderAllTripsWarningSummary() {
        //save trip warnings
        const warnings = this.getWarningsForTrips();
        if (warnings.length === 0) {
            return <div></div>;
        }
        return (
            <div className="otp-warning-legend">
                {warnings}
            </div>
        );
    }

    //Returns trip warning for a single trip
    renderSingleTripWarnings() {
        const warnings = this.getWarningsForTrip(this.props.trip);
        if (warnings.length === 0) {
            return <div></div>;
        }
        return (
            <span className="otp-trip-warnings">
                {warnings}
            </span>
        );
    }

    render() {
        if (this.isSummaryOfAllTrips()) {
            //Render all trip warnings
            return this.renderAllTripsWarningSummary();
        } else {
            //Render single trip warnings
            return this.renderSingleTripWarnings();
        }
    }
}

//set default trips
TripWarnings.defaultProps = {
    trips: []
};


const mapStateToProps = state => {
    return {
        requestDate: state.form.fields.date.value,
    };
};

export default connect(mapStateToProps)(TripWarnings);